import { useCallback } from 'react';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import type { IThemeComponents } from '@bingads-webui-react/with-default-styles';
import { useResponsiveSize } from '@adscore/with-responsive-size';
import type { IWithResponsiveSizeOptions } from '@adscore/with-responsive-size';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';

export type ResponsiveStyleFactory = (
  component: IThemeComponents,
  core: IThemeComponents
) => object;

export interface ResponsiveStyleOptions extends IWithResponsiveSizeOptions {
  component?: IThemeComponents;
}

export const useResponsiveStyles = (
  styles: ResponsiveStyleFactory,
  options: ResponsiveStyleOptions = {}
) => {
  const { offset = 0, component = {} } = options;

  const classes = useDefaultStyles(styles, component);
  const displayMode = useResponsiveSize(Constants.ResponsiveSizeBreakpoints, offset);

  const getStyles = useCallback((className: string): Record<string, boolean> => {
    const classNameWithDisplayMode = `${className}-${displayMode}`;

    const baseStyle = classes[className];
    const responsiveStyle = classes[classNameWithDisplayMode];

    return {
      ...(baseStyle ? { [baseStyle]: true } : {}),
      ...(responsiveStyle ? { [responsiveStyle]: true } : {}),
    };
  }, [classes, displayMode]);

  return getStyles;
};
